var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0625 4.15234L24.8506 7.27832V7.28027H1.14453L3.93359 4.15234H22.0625Z",
    fill: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_429_67337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 21,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54297 23.6699L8.46387 24.6602H17.876L21.7979 23.6699L23.1055 8.60156H3.23438L4.54297 23.6699Z",
    fill: "url(#paint0_linear_429_67337)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_429_67337)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.27509,
    height: 16.0588,
    transform: "matrix(-1 0 0 1 24.1523 8.60156)",
    fill: "#9D9D9D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_429_67337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 21,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8086 23.6699L17.8877 24.6602H8.47559L4.55371 23.6699L3.24609 8.60156H23.1172L21.8086 23.6699Z",
    fill: "url(#paint1_linear_429_67337)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_429_67337)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.47266,
    y: 8.60156,
    width: 9.41263,
    height: 16.0588,
    fill: "#9D9D9D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_429_67337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 21,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8086 23.6699L17.8877 24.6602H8.47559L4.55371 23.6699L3.24609 8.60156H23.1172L21.8086 23.6699Z",
    fill: "url(#paint2_linear_429_67337)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_429_67337)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.19531,
    y: 8.60156,
    width: 6.27509,
    height: 16.0588,
    fill: "#9D9D9D"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2051 1.33789V4.39648H15.6758V2.86719H10.3223V4.39648H8.79297V1.33789H17.2051Z",
    fill: "url(#paint3_linear_429_67337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_429_67337",
    x1: 20.8395,
    y1: 24.3256,
    x2: 18.4266,
    y2: 8.90455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_429_67337",
    x1: 13.1816,
    y1: 8.60156,
    x2: 13.1816,
    y2: 24.6602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_429_67337",
    x1: 5.5121,
    y1: 24.3256,
    x2: 7.92498,
    y2: 8.90455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_429_67337",
    x1: 13.3478,
    y1: 1.72021,
    x2: 13.3478,
    y2: 4.15321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.978598a4460a538ac2e344504b0ac9a4.svg";
export { ForwardRef as ReactComponent };